export default __webpack_public_path__ + "static/media/closet5-before3-1920w.18a6b8ca.avif";